import { useEffect } from 'react';

let isInitialized = false;

export function initGTM(gtmId) {
  if (!gtmId || isInitialized) return;

  isInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.insertBefore(script, document.head.firstChild);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function pushEvent(event, data = {}) {
  if (!isInitialized) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

export function setUserProperties(properties = {}) {
  if (!isInitialized) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(properties);
}

export function usePageView(location) {
  useEffect(() => {
    if (!isInitialized || !location) return;

    pushEvent('page_view', {
      page_path: location.pathname,
      page_search: location.search,
    });
  }, [location?.pathname, location?.search]);
}
